import React from 'react';
import './guestBooking.scss';

const GuestBookingComplete: React.FC = () => (
    <div className="guest-booking">
        <div className="guest-booking__card">
            <h1 className="guest-booking__title">Thank you</h1>
            <p>Your visit request has been submitted and is now pending approval. You can close this window.</p>
        </div>
    </div>
);

export default GuestBookingComplete;
